'use strict';
import angular from 'angular';

/**
 * @author Maxim Seredkin
 */
export default function projectSupportTable() {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: false,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            project: '=myProject',
            edit: '=edit'
        },
        controller: ['$scope', '$utils', 'ProjectSupportService', 'AttachmentService',
            function ($scope, $utils, ProjectSupportService, AttachmentService) {

                $scope.select = select;
                $scope.dblClick = dblClick;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.openSupportTool = openSupportTool;
                $scope.getValue = $utils.getValue;
                $scope.showAttachments = AttachmentService.show;

                init();

                // region Function

                function init() {
                    if (!$scope.selectedItem)
                        $scope.selectedItem = {};

                    $scope.columns = [{
                        name: "Наименование инструмента поддержки",
                        data: "supportTool.name"
                    }, {
                        name: "Дата начала действия",
                        data: "startDate",
                        type: "date",
                    }, {
                        name: "Основание начала",
                        data: "startBase"
                    }, {
                        name: "Дата окончания действия",
                        data: "stopDate",
                        type: "date",
                    }, {
                        name: "Основание окончания",
                        data: "stopBase"
                    }, {
                        name: "Вложения",
                        data: "attachments",
                        type: "attachments"
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null
                    };

                    $scope.refresh = refresh;

                    $scope.toolbox = {
                        buttons: {
                            create: {
                                show: () => $scope.edit,
                                click: () => {
                                    ProjectSupportService.create({}, $scope.edit, $scope.project).result.then(function (data) {
                                        if (!$scope.items.some(item => equals(item, data))) {
                                            $scope.items.push(data);
                                        }
                                    });
                                },
                                disabled: () => false,
                            },
                            edit: {
                                show: () => true,
                                click: (item) => {
                                    ProjectSupportService.edit($scope.selectedItem, $scope.edit, $scope.project).result.then(function (data) {
                                        angular.copy(data, item);
                                        angular.copy(data, $scope.selectedItem);
                                    });
                                },
                                disabled: () => !isSelected(),
                            },
                            remove: {
                                show: () => $scope.edit,
                                click: (item) => $scope.items.splice($scope.items.indexOf($scope.items.find((it) => equals(it, item))), 1),
                                disabled: () => !isSelected(),
                            },
                            refresh: {
                                show: () => false,
                                click: $scope.refresh,
                                disabled: () => false,
                            },
                        }
                    };
                }

                function openSupportTool(item) {
                    $scope.selectedItem = item
                    $scope.toolbox.buttons.edit.click($scope.selectedItem)
                }

                function refresh() {
                    if (Array.isArray($scope.items)) {
                        if ($scope.items.every(i => !equals(i, data))) {
                            $scope.selectedItem = {};
                        }
                    }
                }

                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table' :
                            if ($scope.toolbox.buttons.edit) {
                                $scope.toolbox.buttons.edit.click(item);
                            }
                            break;
                        case 'select' :
                            $scope.ok();
                            break;
                    }
                }

                function select(item) {
                    if (!$scope.isSelect(item)) {
                        angular.copy(item, $scope.selectedItem);
                    } else {
                        angular.copy({}, $scope.selectedItem);
                    }
                }

                function isSelect(item) {
                    return equals($scope.selectedItem, item);
                }

                function isSelected() {
                    return $scope.selectedItem != null && $scope.selectedItem.supportTool != null && $scope.selectedItem.supportTool.id != null;
                }

                function equals(i1, i2) {
                    if (!i1 || !i2) {
                        return false;
                    }

                    if (i1.supportTool && i2.supportTool && i1.startDate && i2.startDate) {
                        return i1.supportTool.id === i2.supportTool.id
                            && i1.startDate.getTime() === i2.startDate.getTime();
                    }

                    return angular.equals(i1, i2);
                }

                function getItems() {
                    return $scope.items;
                }

                // endregion

            }]
    };
}
